var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 32,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.7188 56.7433L54.789 57.7223C54.789 57.7223 52.5787 60.0493 46.5455 53.6975C40.5124 47.3458 42.7227 45.0188 42.7227 45.0188L43.3083 44.4023C44.7508 42.8835 44.8868 40.4452 43.6283 38.6652L41.0537 35.0239C39.496 32.8207 36.4859 32.5296 34.7005 34.4094L31.4959 37.7832C30.6106 38.7153 30.0173 39.9235 30.0892 41.2639C30.2733 44.6929 31.7386 52.0706 39.9147 60.6786C48.5852 69.807 56.7206 70.1698 60.0474 69.8414C61.0997 69.7375 62.0149 69.1701 62.7523 68.3937L65.6526 65.3402C67.6103 63.2791 67.0584 59.7455 64.5535 58.3037L60.6529 56.0586C59.0081 55.1119 57.0043 55.39 55.7188 56.7433Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9167 39.2916C70.9167 44.9295 66.3462 49.4999 60.7083 49.4999C59.0753 49.4999 57.5319 49.1165 56.1631 48.4347C55.7994 48.2535 55.3836 48.1932 54.991 48.2983L52.7186 48.9063C51.7322 49.1702 50.8297 48.2678 51.0936 47.2813L51.7016 45.0089C51.8067 44.6163 51.7464 44.2006 51.5652 43.8368C50.8834 42.468 50.5 40.9246 50.5 39.2916C50.5 33.6537 55.0704 29.0833 60.7083 29.0833C66.3462 29.0833 70.9167 33.6537 70.9167 39.2916ZM60.7083 34.8254C61.7654 34.8254 62.6224 35.6824 62.6224 36.7395V37.3775H63.2604C64.3175 37.3775 65.1745 38.2345 65.1745 39.2916C65.1745 40.3487 64.3175 41.2056 63.2604 41.2056H62.6224V41.8437C62.6224 42.9008 61.7654 43.7577 60.7083 43.7577C59.6512 43.7577 58.7943 42.9008 58.7943 41.8437V41.2056H58.1562C57.0991 41.2056 56.2422 40.3487 56.2422 39.2916C56.2422 38.2345 57.0991 37.3775 58.1562 37.3775H58.7943V36.7395C58.7943 35.6824 59.6512 34.8254 60.7083 34.8254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.205c7ddaddcbb6f01477882d1e813cdc.svg";
export { ForwardRef as ReactComponent };